const DEFAULT_VAT_RATE = 0.22;

export function roundMoney(value) {
  return Math.round((parseFloat(value) || 0) * 100) / 100;
}

export function getTaxableAmount(amount, amountIncludesVat = true, vatRate = DEFAULT_VAT_RATE) {
  const gross = parseFloat(amount) || 0;
  if (!amountIncludesVat) return roundMoney(gross);
  return roundMoney(gross / (1 + vatRate));
}

export function getVatAmount(amount, amountIncludesVat = true, vatRate = DEFAULT_VAT_RATE) {
  const gross = parseFloat(amount) || 0;
  if (!amountIncludesVat) return 0;
  return roundMoney(gross - gross / (1 + vatRate));
}

export function calculateCollectionCommission(amount, commissionPercent) {
  const base = parseFloat(amount) || 0;
  const percent = parseFloat(commissionPercent) || 0;
  if (base <= 0 || percent <= 0) return 0;
  return roundMoney(base * percent / 100);
}

export function accountIncludesVat(account) {
  if (!account) return true;
  return account.amountIncludesVat !== false;
}

/** Margine con IVA sui costi: non aggiunge IVA al ricavo se il conto è imponibile. */
export function getMarginWithVat(paymentAmount, totalCostWithVat, paymentAmountNoVat, includesVat) {
  if (includesVat) {
    return roundMoney(parseFloat(paymentAmount) - totalCostWithVat);
  }
  return roundMoney(paymentAmountNoVat - totalCostWithVat);
}
